import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=6a9491a8&"
import script from "./ShopPage.vue?vue&type=script&lang=js&"
export * from "./ShopPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports